import { buildType } from "@helpers/expo-extras";
import { isDev } from "@memorang/constants/urls";
import { Apps } from "types/apps";
import type { CurrentExamContext } from "./types";

const defaultExamContextMap: Record<Apps, CurrentExamContext> = {
	[Apps.TherapyEd]: {
		projectId: isDev ? 9 : 6,
		organizationId: isDev ? 8 : 3,
		examId: "e61873a5-ffd7-4bed-9745-256da36a16d7",
		examName: "NPTE-PT",
		studyPackCollectionId: isDev ? 42 : 80,
		studyPackProductNumericId: 44,
		practiceTestProductNumericId: 66,
		studyPackProductId: "952aca40-c93d-4656-8814-94264f293ac4",
		practiceTestProductId: "3f789553-1d7d-4049-9ceb-cb610e83e102",
		examIcon: "https://icon.memorang.com/icon/icon_exam_21.png",
	},
	[Apps.aavsb]: {
		projectId: isDev ? 9 : 85,
		organizationId: isDev ? 8 : 2,
		examId: "e974b6af-c245-494f-b9b1-f8d25a8c89d5",
		examName: "Veterinary Technician National Exam",
		studyPackCollectionId: 12,
		studyPackProductNumericId: 191,
		practiceTestProductNumericId: 0,
		studyPackProductId: "6f0b4830-1e18-4f63-a3f0-b419cd4496f2",
		practiceTestProductId: "",
		examIcon:
			"https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/AASVB/apps/app_logo_stacked_light.png",
	},
	[Apps.aapa]: {
		projectId: isDev ? 17 : 41,
		organizationId: isDev ? 8 : 36,
		examId: "f08f78be-2ab6-451f-b81c-385b4e8c8840",
		examName: "PANRE",
		studyPackCollectionId: 628,
		studyPackProductNumericId: 307,
		practiceTestProductNumericId: 0,
		studyPackProductId: "550e8400-e29b-41d4-a716-446655440000",
		practiceTestProductId: "",
		examIcon:
			"https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/aapa/aapa/icons/icon.png",
	},
	[Apps.Psi]: {
		examName: "Life Accident and Health",
		examIcon: "https://icon.memorang.com/icon/icon_exam_1.png",
		projectId: isDev ? 7 : 3,
		organizationId: isDev ? 7 : 2,
		examId: "c2dc2f42-ccbe-428a-81ed-0d45a5b2f001",
		studyPackProductNumericId: 45,
		practiceTestProductNumericId: 72,
		studyPackCollectionId: 263,
		studyPackProductId: "031ed055-d3a3-4a67-9048-5d9658454865",
		practiceTestProductId: "8b8d2b39-1780-4b8c-a270-08053153cad3",
	},
	[Apps.cmaa]: {
		examName: "Certified Associate Construction Manager",
		examIcon:
			"https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/org-ea9e2b44-760e-4963-8255-7727cda0efe4/projects/project-c74b2bbe-16cb-4f04-ab6d-c6f3df67d797/uploads/media/cmaa_associate_construction_manager_prep_bundle.png",
		projectId: isDev ? 7 : 86,
		organizationId: isDev ? 7 : 2,
		examId: "9c3981f8-c690-4bbf-935b-d08557b6d265",
		studyPackCollectionId: 480,
		studyPackProductNumericId: 196,
		studyPackProductId: "0d22c7e8-6783-4a89-b09d-bcb5b5dcb1a3",
		practiceTestProductNumericId: 195,
		practiceTestProductId: "e0165e63-89b4-437e-8f5a-707a04d3b63a",
	},
	[Apps.wpi]: {
		examName: "Water Treatment Class I",
		examIcon:
			"https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/wpi/icons/water_treatment_class_1.png",
		projectId: isDev ? 7 : 84,
		organizationId: isDev ? 7 : 2,
		examId: "921bbcce-51a2-4f38-abcd-39af1bff6138",
		studyPackCollectionId: 0,
		studyPackProductNumericId: 0,
		studyPackProductId: "",
		practiceTestProductNumericId: 211,
		practiceTestProductId: "f3929f8c-1644-4fd1-abe0-473df69423a5",
	},
	[Apps.wocncb]: {
		examName: "Certified Continence Care Nurse",
		examIcon:
			"https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/org-ea9e2b44-760e-4963-8255-7727cda0efe4/projects/project-4c80ce98-ef6c-41c8-ab54-f4db19c75136/uploads/media/wocncb_continence_care_nurse_prep_bundle.png",
		projectId: isDev ? 7 : 87,
		organizationId: isDev ? 7 : 2,
		examId: "02b4592b-7b47-450d-8bb6-a63d82e43953",
		studyPackCollectionId: 629,
		studyPackProductNumericId: 200,
		studyPackProductId: "d1db413b-d89f-4aba-948a-692f3f9e3207",
		practiceTestProductNumericId: 199,
		practiceTestProductId: "dd7e36ee-90fb-4cc1-8e14-78b1b612bfc9",
	},
	[Apps.act]: {
		examName: "ACT",
		examIcon:
			"https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/ACT/icons/icon.png",
		projectId: isDev ? 7 : 108,
		organizationId: isDev ? 7 : 70,
		examId: "ad17e478-7727-4667-b8d5-5c8bcc0d0830",
		studyPackCollectionId: 651,
		studyPackProductNumericId: 313,
		studyPackProductId: "8db8bdf0-e684-4096-9a25-608ff807c159",
		practiceTestProductNumericId: 315,
		practiceTestProductId: "a706513b-047b-4c28-a38c-23c2d1474ee6",
	},
	[Apps.faa]: {
		examName: "Unmanned Aircraft General (UAG)",
		examIcon:
			"https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/faa/icon.png",
		projectId: isDev ? 81 : 54,
		organizationId: isDev ? 7 : 2,
		examId: "87bce8a4-d114-4b38-9b89-1441483e83ae",
		studyPackProductNumericId: 188,
		practiceTestProductNumericId: 187,
		studyPackCollectionId: 40,
		studyPackProductId: "1581febf-d426-49d5-8f5b-51d55509be86",
		practiceTestProductId: "35f12bb1-f9d8-48f0-97f3-26eadf0990ac",
	},
	[Apps.cambridge]: {
		examName: "English Hub",
		examIcon:
			"https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/cambridge/icons/icon.png",
		projectId: isDev ? 62 : 48,
		organizationId: isDev ? 51 : 47,
		examId: isDev
			? "894559fc-2a9e-428d-bbfd-eee0042417b6"
			: "894559fc-2a9e-428d-bbfd-eee0042417b6",
		studyPackProductNumericId: 0,
		studyPackCollectionId: 39,
		studyPackProductId: "",
		practiceTestProductNumericId: 190,
		practiceTestProductId: "3d72cde7-47f7-4d4f-8ea0-c2ad24d3cc89",
	},
	[Apps.toefl]: {
		projectId: isDev ? 61 : 47,
		organizationId: isDev ? 29 : 24,
		examId: "e783a8c3-951c-48c3-9b8a-fd464a27d1d3",
		studyPackProductNumericId: 178,
		studyPackCollectionId: 38,
		examName: "TOEFL",
		studyPackProductId: "6da87b56-3d30-450a-b097-20fc5a360b39",
		practiceTestProductId: "",
		examIcon:
			"https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/toefl/icons/stacked_light.png",
	},
	[Apps.Jbjs]: {
		projectId: isDev ? 13 : 10,
		organizationId: isDev ? 17 : 8,
		examId: "06be055e-878c-43c5-942e-cc78a7d9aa5a",
		examName: "JBJS",
		studyPackProductNumericId: isDev ? 106 : 194,
		studyPackCollectionId: 20,
		studyPackProductId: "",
		practiceTestProductId: "",
		documentsCollectionId: 20,
		examIcon:
			"https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/icons/jbjs_icon.png",
	},
	[Apps.nascla]: {
		examName: "NASCLA Commercial General Building Contractor",
		examIcon:
			"https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/org-ea9e2b44-760e-4963-8255-7727cda0efe4/projects/project-6635a8d9-38e4-4051-928c-42df9e591999/uploads/media/commercial_building_contractor_exam.png",
		projectId: isDev ? 7 : 91,
		organizationId: isDev ? 7 : 2,
		examId: "fbe1b648-7330-4fa6-a652-f2872a7d0997",
		studyPackCollectionId: 522,
		studyPackProductNumericId: 227,
		practiceTestProductNumericId: 226,
		studyPackProductId: "8fe8b405-88ed-40d0-82c1-4fbe8fe12756",
		practiceTestProductId: "1e5447c3-ba0b-44e3-ab1e-d5c0429d1672",
	},
	[Apps.hiset]: {
		examName: "Life Accident and Health",
		studyPackProductNumericId: 45,
		practiceTestProductNumericId: 72,
		studyPackCollectionId: 88,
		projectId: isDev ? 7 : 3,
		organizationId: isDev ? 7 : 2,
		studyPackProductId: "031ed055-d3a3-4a67-9048-5d9658454865",
		practiceTestProductId: "8b8d2b39-1780-4b8c-a270-08053153cad3",
		examId: "c2dc2f42-ccbe-428a-81ed-0d45a5b2f001",
		examIcon: "https://icon.memorang.com/icon/icon_exam_1.png",
	},
	[Apps.rockettestprep]: {
		examName: "Rocket Test Prep",
		studyPackProductNumericId: 267,
		practiceTestProductNumericId: 268,
		studyPackCollectionId: 685,
		projectId: isDev ? 18 : 7,
		organizationId: isDev ? 2 : 4,
		studyPackProductId: "47d9991e-1aac-47d0-8b76-8978bccb551c",
		practiceTestProductId: "c11bc07f-1408-4fd6-a42d-27600cf4fae9",
		examId: "36d854a6-8198-4838-8816-e027679bed9a",
		examIcon: "https://icon.memorang.com/icon/acme.png",
	},
	[Apps.toeic]: {
		examName: "TOEIC Link Prep",
		studyPackProductNumericId: 0,
		practiceTestProductNumericId: 0,
		studyPackCollectionId: 0,
		projectId: isDev ? 18 : 7,
		organizationId: isDev ? 2 : 4,
		studyPackProductId: "",
		practiceTestProductId: "",
		examId: "",
		examIcon:
			"https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/toeic/icons/app_logo_stacked_light.png",
	},
	[Apps.naplex]: {
		examName: "NAPLEX® Practice Test Central",
		studyPackProductNumericId: 0,
		practiceTestProductNumericId: 0,
		studyPackCollectionId: 679,
		projectId: isDev ? 28 : 28,
		organizationId: isDev ? 32 : 27,
		studyPackProductId: "",
		practiceTestProductId: "",
		examId: "daed6dbd-7846-406d-91c5-9277869037b1",
		examIcon:
			"https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/mcgraw-hill-education/icons/app_default_logo_dark.png",
	},
};

export const defaultExamContext = defaultExamContextMap[buildType];
